"use client";
import Button from "@/components/design-system/button";
import { FunctionComponent, useState } from "react";
import ReactMarkdown from "react-markdown";
import styles from "./categoryFAQ.module.scss";

const CategoryFAQ: FunctionComponent<CategoryFAQProps> = ({ frequentlyAskedQuestion }) => {
  const [showAnswer, setShowAnswer] = useState<boolean>(false);

  return (
    <div className={`${styles.categoryFaq} ${showAnswer ? styles.active : ""} mb-3`}>
      <h3>{frequentlyAskedQuestion.detailHeader}</h3>
      <div className={`${showAnswer ? "d-block" : "d-none"} pt-1 pb-2`}>
        <ReactMarkdown>{frequentlyAskedQuestion.detailBody}</ReactMarkdown>
      </div>
      <Button
        variant="tertiary"
        color="blue"
        text={showAnswer ? "Less" : "More"}
        showLeftIcon={false}
        showRightIcon={false}
        onClick={() => setShowAnswer(!showAnswer)}
      />
    </div>
  );
};

export type CategoryFAQProps = {
  frequentlyAskedQuestion: CategoryFAQs;
};

export default CategoryFAQ;
